/**
 * 物料 originalSerialList 精確比對（trim 後全等）。
 *
 * @param {object[]} rows
 * @param {string} code
 * @returns {object[]}
 */
export function matchMtrsByOriginalSerial(rows = [], code) {
  const needle = String(code ?? '').trim();
  if (!needle) {
    return [];
  }

  return (Array.isArray(rows) ? rows : []).filter((row) => {
    const list = row?.originalSerialList;
    if (!Array.isArray(list) || list.length === 0) {
      return false;
    }
    return list.some((item) => String(item ?? '').trim() === needle);
  });
}
